<template>
  <div class="account-page">
    <AccountPanel title="Lista użytkowników">
      <div class="table-responsive">

        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">imię</th>
            <th scope="col">nazwisko</th>
            <th scope="col">e-mail</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="account in user.accounts">
            <td>{{account.backup.forname}}</td>
            <td>{{account.backup.surname}}</td>
            <td>{{account.backup.email}}</td>
            <td></td>
         </tr>
          </tbody>
        </table>
      </div>
    </AccountPanel>

  </div>

</template>

<script>

  import { mapState } from 'vuex';
  import AccountPanel from './AccountPanel.vue'

  export default {
    components: {AccountPanel},
    computed: {
      ...mapState({
        user: state => state.user
      }),
    },
    beforeMount() {

      if (!this.$store.state.user.authorizedUser) {
        this.$router.replace({name: 'mainPage'});
      }

      this.$store.dispatch('user/getAccounts');
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/UsersList.vue